export default __webpack_public_path__ + "static/media/hacker-rank-1.74b3308d.png";